// The knowledge HTTP wire contract (ADR-0019; slice-plan.md:50-58).
//
// The SINGLE source of truth for GET /v1/apps/:appId/knowledge-doc and
// POST /v1/apps/:appId/ask-crew that BOTH apps/api (producer) and apps/web (consumer) build
// against - pinned here in Wave 1 so the two sides cannot drift (the Slice-2 wire-drift lesson,
// dispatch-plan.md). The success payloads are the domain schemas from ../ports/knowledge.ts;
// this file adds the path params, the request body, and the shared error envelope.
import { z } from "zod";
import { AppId } from "../ids.js";
import { AskCrewAnswer, AskCrewQuestion, KnowledgeDoc } from "../ports/knowledge.js";
/**
 * The wire error body every knowledge route returns on failure: `{ code, message }`. This is the
 * existing idiom (result.ts `AppError`; apps/web errors.ts `BoundaryError`) as a parseable schema,
 * so both sides narrow ONE shape. `code` is a free non-empty string (each endpoint documents its
 * own codes: `unauthorized | forbidden | not_found | validation | unavailable`); a `not_found`
 * and a `forbidden` on an app that is not the caller's return a byte-identical not-found
 * (app-security §2, A01 - existence is not revealed). `message` is user-safe: no stack trace,
 * SQL, provider payload, secret, or PII.
 */
export const ErrorEnvelope = z.object({
    code: z.string().min(1),
    message: z.string(),
});
/** Path params for both knowledge routes: the one app the request is scoped to (D43). */
export const KnowledgeRouteParams = z.object({ appId: AppId });
/** GET /v1/apps/:appId/knowledge-doc -> 200 `KnowledgeDocResponse`, else an `ErrorEnvelope`. */
export const KnowledgeDocResponse = KnowledgeDoc;
/** POST /v1/apps/:appId/ask-crew request body (the scoped question; D43/D53). */
export const AskCrewRequest = AskCrewQuestion;
/** POST /v1/apps/:appId/ask-crew -> 200 `AskCrewResponse`, else an `ErrorEnvelope`. */
export const AskCrewResponse = AskCrewAnswer;
//# sourceMappingURL=knowledge.js.map